import { render, staticRenderFns } from "./AnadirAPaginaInicioIOS.vue?vue&type=template&id=ad65131a&scoped=true&"
import script from "./AnadirAPaginaInicioIOS.vue?vue&type=script&lang=js&"
export * from "./AnadirAPaginaInicioIOS.vue?vue&type=script&lang=js&"
import style0 from "./AnadirAPaginaInicioIOS.vue?vue&type=style&index=0&id=ad65131a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad65131a",
  null
  
)

export default component.exports